/**
 * PrimeVue Configuration
 * 
 * This file configures PrimeVue theme and components.
 * PrimeVue is being set up alongside Ant Design Vue for gradual migration.
 */

// PrimeVue component configuration
export const primevueConfig = {
  // Ripple effect (can be disabled if not needed)
  ripple: true,
  // Input style (outlined, filled, or underlined)
  inputStyle: 'outlined' as const,
  // Z-index configuration
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
  },
};

// Theme configuration - using Aura theme by default
// You can customize the theme by modifying the CSS variables in primevue-overrides.scss
// or by using PrimeVue's theme builder: https://primevue.org/theming/
export const primevueTheme = {
  // Theme name - using 'aura' which is imported via CSS
  // For custom themes, you can define them here or use CSS variables
};

